import {
  navEnter,
  navToScroll,
  navToPage,
  yearMenuIn,
  yearMenuOut,
} from './timelines/navigator';
import {
  titleIn,
  titleInPage,
  titleOut,
  titleZoom,
  textIn,
  yearIn,
  yearOut,
  paragraphIn,
} from './timelines/typography';
import {
  buttonToClose,
  buttonToDiscover,
  buttonIn,
  buttonInPage,
  buttonOut,
  buttonInLoader,
  buttonSetLoader,
} from './timelines/button';
import { picture } from './timelines/picture';

const animations = new Map();

animations.set('navEnter', navEnter);
animations.set('navToScroll', navToScroll);
animations.set('navToPage', navToPage);
animations.set('yearMenuIn', yearMenuIn);
animations.set('yearMenuOut', yearMenuOut);
animations.set('buttonToDiscover', buttonToDiscover);
animations.set('buttonOut', buttonOut);
animations.set('buttonIn', buttonIn);
animations.set('buttonInLoader', buttonInLoader);
animations.set('buttonInPage', buttonInPage);
animations.set('buttonToClose', buttonToClose);
animations.set('buttonSetLoader', buttonSetLoader);
animations.set('titleIn', titleIn);
animations.set('titleInPage', titleInPage);
animations.set('titleOut', titleOut);
animations.set('titleZoom', titleZoom);
animations.set('paragraph', paragraphIn);
animations.set('yearIn', yearIn);
animations.set('yearOut', yearOut);
animations.set('textIn', textIn);
animations.set('picture', picture);

export default animations;
